<script lang="ts" setup>
import MImageLoader from '@/components/molecules/forms/ImageLoader.vue'
import AButton from '~/components/atoms/buttons/Button.vue'
import { ButtonSize, ButtonStyle } from '~/static/enums/components/button'
import { useRemovalBackgroundStore } from '~/store/removal-background'

const imageStore = useRemovalBackgroundStore()
const changeImage = (file: File): void => {
  imageStore.loadImageWithBackgroundRemoved(file)
  useRouter().push('/file')
}

</script>

<template>
  <div class="container-fluid">
    <div class="content">
      <h1 class="mb-2 mb-md-3 title">
        Такой страницы нет
      </h1>
      <p class="mb-0 fs-5">
        Но&nbsp;мы&nbsp;уверены, что вы&nbsp;пришли по&nbsp;адресу 😉
      </p>
      <p class="mb-32 fs-5">
        Хотите создать инфографику для маркетплейса?
      </p>
      <MImageLoader
        v-slot="scope"
        @change="changeImage"
      >
        <AButton
          :button-style="ButtonStyle.Primary"
          @click="scope.loadImage"
          :button-size="ButtonSize.Large"
        >
          Загрузить фото товара
        </AButton>
      </MImageLoader>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.title {
  @include media-breakpoint-down(md) {
    font-size: rem(32px);
  }
}

.content {
  margin: rem(100px) 0;

  @include media-breakpoint-down(lg) {
    margin: rem(40px) 0;
  }

  @include media-breakpoint-down(md) {
    margin: rem(24px) 0;
  }
}
</style>
